export type RowCountGetter = (
  // any here to match ag-grids row getter params
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterModel: any
) => Promise<number | undefined>;
